/**
 * Subscribes to an observable and retains a reference to the subscriber.
 *
 * @see {@link Subscription.SubscriberRetaining}
 *
 * @internal scope: workspace
 */
export function subscribeWithRetention(observable, subscriber) {
    const subscription = observable.subscribe(subscriber);
    return {
        subscriber,
        unsubscribe() {
            subscription.unsubscribe();
        },
    };
}
